module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Regular.7eb522c.otf";